import Popper from "popper.js";

class ResponsiveMenu {
  static BREAKPOINTS = [
    { breakpoint: 1280, items: 6 },
    { breakpoint: 768, items: 4 },
    { breakpoint: 575, items: 4 },
    { breakpoint: 400, items: 2 },
    { breakpoint: 380, items: 1 },
    { breakpoint: 0, items: 1 },
  ];

  constructor(options) {
    this.menuItems = options.menuItems;

    this.dropdown = options.dropdown;
    this.dropdownItems = options.dropdownItems;
    this.dropdownTrigger = options.dropdownTrigger;

    this.popper = null;

    this.dropdownOpen = false;

    this.init();
  }

  init = () => {
    this.checkMenuOverflow();

    this.popper = new Popper(this.dropdownTrigger, this.dropdown, {
      modifiers: {
        preventOverflow: {
          enabled: true,
          padding: 15,
          boundariesElement: "viewport",
        },
        offset: {
          offset: "0, 5px, 0, 0",
        },
      },
    });

    this.dropdownTrigger.addEventListener("click", this.toggleDropdown);
  };

  checkMenuOverflow = () => {
    const breakpoint = ResponsiveMenu.BREAKPOINTS.find(
      (xxx) => window.innerWidth >= xxx.breakpoint
    );

    this.menuItems.forEach((item, index) => {
      if (index + 1 > breakpoint.items) {
        item.setAttribute("hidden", "");
      } else {
        item.removeAttribute("hidden");
      }
    });

    this.dropdownItems.forEach((item, index) => {
      if (index + 1 > breakpoint.items) {
        item.removeAttribute("hidden");
      } else {
        item.setAttribute("hidden", "");
      }
    });

    if (this.menuItems.length - 1 > breakpoint.items) {
      this.dropdownTrigger.removeAttribute("hidden");
    } else {
      this.dropdownTrigger.setAttribute("hidden", "");
    }

    window.setTimeout(() => {
      window.requestAnimationFrame(this.checkMenuOverflow);
    }, 500);
  };

  listenForClickOutside = (event) => {
    try {
      if (this.dropdown.contains(event.target) === false) {
        this.closeDropdown();
      }
    } catch (error) {
      // error
    }
  };

  listenForEscape = (event) => {
    if (event.keyCode === 27) {
      this.closeDropdown();
    }
  };

  toggleDropdown = () => {
    (this.dropdownOpen ? this.closeDropdown : this.openDropdown)();
  };

  openDropdown = () => {
    this.dropdownOpen = true;
    this.dropdown.removeAttribute("hidden");

    window.requestAnimationFrame(() => {
      this.popper.update();

      window.addEventListener("click", this.listenForClickOutside);
      window.addEventListener("keydown", this.listenForEscape);
    });
  };

  closeDropdown = () => {
    this.dropdownOpen = false;
    this.dropdown.setAttribute("hidden", "");

    window.removeEventListener("click", this.listenForClickOutside);
    window.removeEventListener("keydown", this.listenForEscape);
  };
}

export default ResponsiveMenu;
